import { ChainInfo, KeplrController, StationController, WalletController, WalletName, WalletType } from "cosmes/wallet";
import { CHAIN_ID, DENOM, GAS_PRICE, RPC_URL, WC_PROJECT_ID } from "./Constants";

const WALLET_SETTINGS: Record<string, { controller: WalletController, name: string }> = {
    [WalletName.STATION]: {
        controller: new StationController(),
        name: "Terra Station"
    },
    [WalletName.KEPLR]: {
        controller: new KeplrController(WC_PROJECT_ID),
        name: "Keplr"
    }
};

export class WalletSupport {
    private _controller: WalletController;

    constructor(private _name: WalletName, private _type: WalletType) {
        this._controller = WALLET_SETTINGS[_name].controller;
    }

    get controller() {
        return this._controller;
    }

    get type() {
        return this._type;
    }

    get name() {
        return WALLET_SETTINGS[this._name].name;
    }

    async connect() {
        const chainInfo: ChainInfo<string> = {
            chainId: CHAIN_ID,
            gasPrice: {
                amount: GAS_PRICE,
                denom: DENOM
            },
            rpc: RPC_URL
        }
        const result = await this._controller.connect(this._type, [chainInfo])
        return result.get(CHAIN_ID)
    }

    async isInstalled() {
        return await this._controller.isInstalled(this._type)
    }
}

export const SUPPORTED_WALLETS = [
    new WalletSupport(WalletName.STATION, WalletType.EXTENSION),
    new WalletSupport(WalletName.STATION, WalletType.WALLETCONNECT),
    new WalletSupport(WalletName.KEPLR, WalletType.EXTENSION),
    new WalletSupport(WalletName.KEPLR, WalletType.WALLETCONNECT),
]